
import Vue from 'vue'
import AppMixin from '@/_mixins/app'
import { hours, minutes } from '@/types/time'
import lodash from 'lodash'

const TimePicker = Vue.extend({
    inheritAttrs: false,
    mixins: [AppMixin],
    props: {
        value: {
            type: String,
            required: false,
            default: '00:00',
        },
    },

    data() {
        return {
            content: this.value,
            hours: hours,
            hour: this.value.split(':')[0],
            minutes: minutes,
            minute: this.value.split(':')[1],
            timePicker: this.value,
        }
    },

    computed: {
        time() {
            return {
                minute: this.minute,
                hour: this.hour,
            }
        },
    },

    methods: {
        checkHours() {
            if (isNaN(this.hour)) {
                this.hour = this.hour
                    .split('')
                    .filter((letter) => !isNaN(letter))
                    .join('')
            } else {
                if (this.hour.length == 1) {
                    this.hour = `0${this.hour}`
                } else if (this.hour.length == 2) {
                    if (0 > this.hour || this.hour > 23) {
                        this.hour = `0${this.hour[1]}`
                    }
                } else {
                    if (0 > this.hour.slice(-2) || this.hour.slice(-2) > 23) {
                        this.hour = `0${this.hour.slice(-1)}`
                    } else {
                        this.hour = `${this.hour.slice(-2)}`
                    }
                }
            }
        },
        checkMinutes() {
            if (isNaN(this.minute)) {
                this.minute = this.minute
                    .split('')
                    .filter((letter) => !isNaN(letter))
                    .join('')
            } else {
                if (this.minute.length == 1) {
                    this.minute = `0${this.minute}`
                } else if (this.minute.length == 2) {
                    if (0 > this.minute || this.minute > 59) {
                        this.minute = `0${this.minute[1]}`
                    }
                } else {
                    if (0 > this.minute.slice(-2) || this.minute.slice(-2) > 59) {
                        this.minute = `0${this.minute.slice(-1)}`
                    } else {
                        this.minute = `${this.minute.slice(-2)}`
                    }
                }
            }
        },
    },

    watch: {
        time: lodash.debounce(function (this) {
            if (-1 < this.hour && this.hour < 24 && -1 < this.minute && this.minute < 60) {
                this.$emit('input', `${this.hour}:${this.minute}`)
            }
        }, 1000),
        timePicker: {
            immediate: false,
            handler() {
                this.hour = this.timePicker.split(':')[0]
                this.minute = this.timePicker.split(':')[1]
            },
        },
    },
})

export default TimePicker
